export const GET_ERRORS  = 'GET_ERRORS'
export const CLEAR_ERRORS  = 'CLEAR_ERRORS'
export const CREATE_MESSAGE  = 'CREATE_MESSAGE'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'